module.exports = __webpack_public_path__ + "static/media/travel.47a3dee9.jpeg";